<template>
  	<v-app>
		<v-content>
			<router-view></router-view>
		</v-content>
  	</v-app>
</template>

<script>
	import Vue from 'vue'
	import axios from 'axios'
	Vue.prototype.$http = axios
	export default {
		name: 'App',
	}
</script>

<style lang="scss">
	body {
		overflow: hidden;
	}
	#app {

		padding-bottom: 40px;

		.v-card__actions {
			width: 70%;
			margin: 0 auto;
			button {
				width: 48%;
				text-transform: capitalize;
			}
		}

		.v-progress-circular{
			margin: 15px;
		}

		.v-navigation-drawer {
			.active {
				background-color: rgba(112, 112, 112, 0.2) !important;
			}
		}

		.word-break {
			word-break: break-all;
		}

		.v-input--selection-controls.v-input--radio-group {
			margin-top: 0;
			padding-top: 0;

			.v-icon {
				font-size: 28px;
			}

			.v-input__control {
            	flex-grow: 1;
			}

			.v-icon {
				color: #5c97ba;
			}

			.v-ripple__container {
				display: none;
			}

			.v-input--selection-controls__ripple {
				width: 23px;
				height: 23px;
				left: -4px;
				top: -7px;
				box-shadow: 0 3px 6px rgba(0,0,0,0.25);
			}
		}

		.vc-sketch-field .vc-input__input {
            font-size: 12px;
            text-align: center;
            padding: 0;
        }

		.vue-numeric-input.updown .btn-decrement {
			box-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);
		}

		.confirm-password-section {
			.reconfirmed-pass{
				display: none;
			}
		}

		.simplebar-scrollbar {
			width: 5px;
			&:before {
				background: #ded5d5;
				left: -5px;
				right: 5px;
			}
		}

		.v-text-field__details {
			padding-top: 4px;
		}

		.square-button {
			width: 66px;
			height: 66px;
			transition: background-color .15s ease;
			&:hover {
				background-color: rgba(112, 112, 112, 0.1);
			}
		}

		.vue-numeric-input {
			height: 66px;
			width: 100% !important;
		}
		.vue-numeric-input.updown .numeric-input {
			padding-left: 16px;
			padding-right: 0;
			height: inherit;
			outline: none;
			border: none;
			color: #707070;
			
		}

		.vue-numeric-input .btn {
			width: 64px;
			right: 0;
			background: #FFFFFF;
			box-shadow: none;
			border: none;
			box-shadow: 0 0 6px rgba(0,0,0,0.25);
			-webkit-box-shadow: 0 0 6px rgba(0,0,0,0.25);
			-moz-box-shadow: 0 0 6px rgba(0,0,0,0.25);
			transition: background-color .15s ease;
			cursor: pointer;
			&:hover {
				background-color: rgba(112, 112, 112, 0.1);
			}
		}

		.v-text-field.v-text-field--enclosed .v-input__slot {
            ::-webkit-input-placeholder {
                font-style: italic;
				color: rgba(112, 112, 112, 0.3);
            }
            ::-moz-placeholder {
                font-style: italic;
				color: rgba(112, 112, 112, 0.3);
            }
            :-ms-input-placeholder {
                font-style: italic;
				color: rgba(112, 112, 112, 0.3);
            }
            :-moz-placeholder {
                font-style: italic;
				color: rgba(112, 112, 112, 0.3);
            }
        }
		* {
			font-family: "Segoe UI" !important;
		}
		.hide-on-mobile {
			@media (max-width: 959px) {
				display: none !important;
			}
		}
		.material-icons {
			font-family: 'Material Icons' !important;
		}
		font-size: 16px;
		background-color: #eee;
		button {
			outline: none;
		}
		.v-btn {
			border-radius: 5px;
			&.text-icon-button {
				.v-btn__content {
					justify-content: space-between;
					width: 100%;
				}
			}
		}
		.v-btn--large {
			height: 55px;
			width: 100%;
		}

		.close-notification {
			text-decoration: none;
		}
	}
	.hide {
		display: none !important;
	}
	.content-section {
		padding-top: 25px;
		height: 66px;
	}
	.v-menu__content {
		transform: translateY(66px);
	}
	.large-button-width {
		width: 252px !important;
	}
	.table-content {
		.edit-btn {
			@media (max-width: 599px) {
				margin: 0 !important;
				padding: 0 !important;
				span {
					display: none !important;
				}
				&:before {
					display: none;
				}
			}
		}
		.layout {
			transition: background-color .15s ease-in;
			&:hover {
				background-color: #FF000017 !important;
			}
		}
	}
	.theme--light.v-divider {
		border-color: #ececec;
	}
	.cc__box-shadow {
		box-shadow: 0 3px 6px rgba(0,0,0,0.25);
        -webkit-box-shadow: 0 3px 6px rgba(0,0,0,0.25);
        -moz-box-shadow: 0 3px 6px rgba(0,0,0,0.25);
	}
	.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) .v-input__slot {
		box-shadow: 0 3px 6px rgba(0,0,0,0.25);
        -webkit-box-shadow: 0 3px 6px rgba(0,0,0,0.25);
        -moz-box-shadow: 0 3px 6px rgba(0,0,0,0.25);
	}
	.relative {
		position: relative;
		z-index: 1;
	}
	.v-messages__message {
		height: 16px;
	}
	.v-textarea {
		height: 204px;
		.v-input__slot * {
			height: 100%;
		}
		textarea {
			padding-top: 16px;
		}
	}
	.theme--light.v-text-field--solo .v-input__slot {
		border-radius: 0;
	}
	.v-navigation-drawer {
		.v-list {
			display: flex;
			flex-direction: column;
			padding-bottom: 66px !important;
			@media (min-width: 768px) {
				height: calc(100vh - 114px);		
			}
			& > div {
				&:last-of-type {
					margin-top: auto;
				}
			}
		}
	}
	.cc__checkbox {
		position: relative;
		margin-top: 0;
		.v-messages {
			pointer-events: none;
		}
		.v-input__control {
			height: 55px;
		}
		.v-label {
			color: #707070;
			z-index: 1;
		}
		.v-input--selection-controls__input {
			-webkit-box-align: center;
			-ms-flex-align: center;
			align-items: center;
			-webkit-box-pack: center;
			-ms-flex-pack: center;
          	justify-content: center;
			width: 55px;
			height: 55px;
			border: 3px solid #707070;
			margin-right: 24px;
			box-shadow: 0 3px 6px rgba(0,0,0,0.25);
			-webkit-box-shadow: 0 3px 6px rgba(0,0,0,0.25);
			-moz-box-shadow: 0 3px 6px rgba(0,0,0,0.25);
			transition: all .15s ease;
			.v-icon {
				font-size: 21px;
				display: none;
			}
			input {
				max-height: unset;
			}
			.v-input--selection-controls__ripple {
				top: 0;
				left: 0;
				bottom: 0;
				right: 0;
			}
		}
		&:after {
			pointer-events: none;
			content: "checked";
			font-family: 'Material Icons';
			position: absolute;
			left: 17px;
			top: 16px;
			width: 18px;
			font-size: 21px;
			pointer-events: none;
			transform: scale(0);
			transition: transform .1s ease;
		}
		&.v-input--is-label-active {
			.v-input--selection-controls__input {
				border: 3px solid #2D99DA;
				background-color: #FFFFFF;
			}
			&:after {
				transform: scale(1);
			}
		}
		&.full-width {
			.v-input__control {
				width: 100%;
			}
		}
		&.label__left {
			.v-input__control {
                .v-input--selection-controls__input {
                    position: absolute;
                    right: 0;
					top: 1px;
					margin-right: 0;
                }
            }
			&:after {
				left: unset;
				right: 19px;
				top: 24px;
			}
			.v-label {
				top: 18px;
				width: calc(100% - 60px);
			}
		}

		&.bold__icon {
			&:after {
				font-weight: 700;
			}
		}
	}

	.form-section {
        .v-text-field.v-text-field--enclosed .v-text-field__details, .v-text-field.v-text-field--enclosed .v-input__slot {
            padding-left: 40px;
        }
        .v-input__slot {
            margin-bottom: 0;
        }
    }

	.notification-content {
		height: 140px;
		line-height: 140px;
		text-align: center;

		&.warnings {
			height: unset;
			line-height: unset;
			padding: 16px 0;
		}

		.warning-list-item {
			font-size: 13px;
		}
	}

	.notification-heading {
		text-align: right;
		line-height: 66px !important;
	}

	.notification-close {
		border-radius: 50%;
		padding: 3px;
	}

	.v-btn:not(.v-btn--depressed):not(.v-btn--flat) {
		box-shadow: 0 3px 6px rgba(0,0,0,0.25);
        -webkit-box-shadow: 0 3px 6px rgba(0,0,0,0.25);
        -moz-box-shadow: 0 3px 6px rgba(0,0,0,0.25);
	}
	.standard-height {
		height: 66px;
		line-height: 18px;
	}
	.table-row {

		@media (max-width: 1263px) {
			padding-left: 0 !important;
			padding-right: 0 !important;
		}
		.sort-btn {
			@media (min-width: 600px) and (max-width: 959px) {
				margin-left: 0 !important;
			}	
		}
		.subheading {
			@media (max-width: 1263px) {
				font-size: 10px !important;
			}
			@media (min-width: 1264px) and (max-width: 1903px) {
				font-size: 13px !important;
			}
			@media (max-width: 479px) {
				word-break: break-all;
				font-size: 9px !important;
			}
		}
		& > .flex {
			display: flex;
			align-items: center;
			padding-top: 5px;
			padding-bottom: 5px;
			min-height: 50px;
			@media (max-width: 599px) {
				padding-left: 2px !important;
			}
		}
		.link {
			text-decoration: underline;
		}
		.justify-center {
			.subheading {
				text-align: center;
			}
		}
	}
	.v-form > .container > .layout:not(:only-child) {
		margin: unset;
	}
	.v-select__slot {
		label {
			color: #FFFFFF !important;
			font-weight: 700;
		}
		.v-input__icon {
			i {
				color: #000;
			}
		}
	}
	.v-select.v-select--is-menu-active .v-input__slot {
		z-index: 8;
	}
	.v-select__selection {
		color: #707070;
	}

	.v-select-list .v-list {
		padding: 0;
		.v-list__tile {
			height: 66px;
		}
	}

	.theme--light.v-list .v-list__tile--link:hover, .theme--light.v-list .v-list__tile--highlighted, .theme--light.v-list .v-list__group__header:hover {
		background: rgba(112, 112, 112, 0.2);
	}

	.v-picker {
		z-index: 1;
		margin-top: -1px;
		position: absolute;
		left: 0;
		top: 0;
	}

	.v-select-list {
		.v-list__tile__title {
			color: #707070;
		}
	}

	.v-input--is-focused {
		.v-icon {
			color: #000 !important;
		}
	}

	.file-uploader-wrapper {
		height: 286px;
		position: relative;
		.file-uploader-bottom {
			position: absolute;
			left: 0;
			right: 0;
			bottom: 0;
			line-height: 66px;
			height: 66px;
			span {
				display: inline-block;
				width: calc(100% - 75px);
				word-break: break-all;
				line-height: initial;
			}
		}
		.upload-button {
			float: right;
			i {
				transition: transform .1s ease;
			}
			&:hover {
				i {
					transform: translateY(-4px);
				}
			}
		}
	}

	.pull-right {
		float: right !important;
	}

	.standard-lh {
		line-height: 66px;
	}

	.contract {
        @media (min-width: 960px) {
            min-height: 980px;
        }
        @media (min-width: 600px) and (max-width: 959px) {
            min-height: 1130px;
        }
        @media (max-width: 599px) {
            min-height: 1440px;
        }
        .date-picker__from {
            z-index: 2;
        }
		.contract-checkboxes {
			@media (min-width: 1904px) {
				padding-left: 40px !important;
			}
		}
    }
	.list-scroll-section {
		overflow-x: hidden;
		background-color: #FFFFFF;
		height: calc(100vh - 66px) !important;
		@media (min-width: 768px) {
			height: calc(100vh - 402px) !important;
		}

		.simplebar-content {

			.request-info {
				height: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
			}
		}
	}

	.sort-content {
		&.justify-center {
			span {
				@media (min-width: 600px) {
					transform: translateX(-16px); //half of the width of sort button
				}
			}
		}
	}

	.no-data-container {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
	}

	.full-width {
		width: 100%;
	}

	.disabled {
		.v-input__slot {
			background: #F7F7F7 !important;
			border: 1px solid #F2F2F2;
			box-shadow: 0px 3px 10px rgba(210, 210, 210, 0.2);
		}
		.v-input__slot, input {
			cursor: not-allowed !important;
		}
	}

	.mb-1__custom {
		margin-bottom: 2px !important;
	}

	.auth-method__checkbox {
        padding-left: 20px;
        
        .v-input--selection-controls__input {
            margin-right: 46px;

			@media (max-width: 767px) {
				margin-right: 24px;
			}
        }
    }

	.display-flex {
		display: flex;
	}
	
	.ellipsis--text {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

</style>